import { Box, type SxProps, Typography } from '@mui/material';
import type React from 'react';

import { palette, spaces } from '../../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../../utils/getMuiIcon';

const EmptySearchStateImage: React.FC<{
	title: string;
	subtitle: string | React.ReactNode;
	containerSx?: SxProps;
	subtitleSx?: SxProps;
	iconName?: Parameters<typeof getMuiIcon>[0];
	iconContainerSx?: SxProps;
}> = ({ title, subtitle, containerSx, subtitleSx, iconName = 'invalidLink', iconContainerSx }) => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				alignItems: 'center',
				paddingBottom: spaces.xxl,
				...containerSx,
			}}
			data-testid="empty-state-container"
		>
			<Box
				component={getMuiIcon(iconName)}
				sx={{
					width: '375px',
					height: '300px',
					...iconContainerSx,
				}}
			/>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					gap: spaces.xs,
				}}
			>
				<Typography variant="h6" color={palette.text.primary} textAlign="center">
					{title}
				</Typography>
				<Typography
					variant="body2"
					component="div"
					color={palette.text.secondary}
					sx={{
						...subtitleSx,
						'& a': {
							color: palette.primary.main,
							textDecoration: 'underline',
							'&:hover': {
								textDecoration: 'none',
							},
						},
					}}
					data-testid="empty-state-subtitle"
				>
					{subtitle}
				</Typography>
			</Box>
		</Box>
	);
};

export default EmptySearchStateImage;
